import GoogleFontSelector from '../common/GoogleFontSelector';
export default function ToggleableInputGroup({
  label,
  placeholder,
  checked,
  onCheckedChange,
  value,
  onValueChange,
  showFontControls = false,
  fontFamily,
  onFontFamilyChange,
  fontSize,
  onFontSizeChange,
}) {
  return (
    <div className="title-wrapper">
      <div className="input-row">
        <div className="input-group p-title">
          <div>{label}</div>
          <label className="checkbox-wrapper">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => onCheckedChange(e.target.checked)}
              className="checkbox-input"
            />
            <span className="checkbox-custom" />
          </label>
        </div>
      </div>

      {(checked && showFontControls) && (
        <>
        <div className="input-row text-input">
            <input
              type="text"
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
              placeholder={placeholder}
            />
        </div>
        {showFontControls && (
          <div className="input-row text-input">
            <div className="font-controls">
              <div className="font-control">
                <label>Font Family:</label>
                <GoogleFontSelector
                  value={fontFamily}
                  onChange={(val) =>
                    onFontFamilyChange(val)
                    //setPersonalSettings({ ...personalSettings, titleFontFamily: val })
                  }
                />
              </div>

              <div className="font-control" style={{ marginTop: '12px' }}>
                <label>Font Size: {fontSize}px</label>
                <input
                  type="range"
                  min={12}
                  max={72}
                  value={fontSize}
                  onChange={(e) => onFontSizeChange(Number(e.target.value))}
                />
              </div>
            </div>
          </div>
        )}
        </>
      )}
      <div className='divider'></div>
    </div>
  );
}
